<template>
  <div>
    <pie-chart  :options="chartOptions" :chart-data="datacollection" ref="chart" v-bind:style="'width:' + width + ';height:' + height"></pie-chart>
  </div>
</template>

<script>
  import PieChart from "./PieChart.js";

  export default {
    name: "simple-pie-chart",
    components: {
      PieChart,
    },
    props: {
      width: {
        required: false,
          type: String,
          default: "150px"
      },
      height: {
        required: false,
        type: String,
        default: "150px"
      }
    },
    data() {
      return {
        chartOptions: {
          hoverBorderWidth: 20,
          legend: {
            display: false,
          },
        },
        datacollection: null,
        
      };
    },
    mounted() {
      this.setData(["olle", "bertil", "oskar"], [33.33, 33.33, 33.33]);
      this.setData(["anna", "jenny"], [60, 40]);
      this.setData(["olle", "bertil", "oskar"], [33.33, 33.33, 33.33]);
    },
    methods: {
      
      setData(labels, data) {

        var collection = {
          hoverBackgroundColor: "red",
          hoverBorderWidth: 10,
          labels: ["Green", "Red", "Blue"],
          datasets: [
            {
              label: "Data One",
              backgroundColor: ["#92D050", "#12AEF5", "#EFA919", "#8B9EB5", "#5A81A6", "#B6E874"],
              data: [],
            }]
        }
        collection.labels = labels;
        collection.datasets[0].data = data;
        this.datacollection = collection;
      },
    },

  };
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/charts/simple-pie-chart.vue